/**
 * @generated SignedSource<<ad17cac6eff794031dcad067cf7a286e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegistriesChooserQuery$variables = {
  registryAddSearch?: string | null;
  team: string;
  teamSelector?: any | null;
};
export type RegistriesChooserQuery$data = {
  readonly team: {
    readonly " $fragmentSpreads": FragmentRefs<"RegistriesChooser_team">;
  } | null;
};
export type RegistriesChooserQuery = {
  response: RegistriesChooserQuery$data;
  variables: RegistriesChooserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registryAddSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "team"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamSelector"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "team"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistriesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "registryAddSearch",
                "variableName": "registryAddSearch"
              },
              {
                "kind": "Variable",
                "name": "teamSelector",
                "variableName": "teamSelector"
              }
            ],
            "kind": "FragmentSpread",
            "name": "RegistriesChooser_team"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RegistriesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "NAME"
                  },
                  {
                    "kind": "Variable",
                    "name": "search",
                    "variableName": "registryAddSearch"
                  },
                  {
                    "kind": "Variable",
                    "name": "team",
                    "variableName": "teamSelector"
                  }
                ],
                "concreteType": "RegistryConnection",
                "kind": "LinkedField",
                "name": "registries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegistryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Registry",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Permission",
                "kind": "LinkedField",
                "name": "teamRegistryCreate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f8b3729581c5179a710fd81b421648e",
    "id": null,
    "metadata": {},
    "name": "RegistriesChooserQuery",
    "operationKind": "query",
    "text": "query RegistriesChooserQuery(\n  $team: ID!\n  $registryAddSearch: String\n  $teamSelector: TeamSelector\n) {\n  team(slug: $team) {\n    ...RegistriesChooser_team_vfPVS\n    id\n  }\n}\n\nfragment RegistriesChooser_team_vfPVS on Team {\n  id\n  slug\n  organization {\n    registries(search: $registryAddSearch, first: 10, order: NAME, team: $teamSelector) {\n      edges {\n        node {\n          id\n          name\n          slug\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    teamRegistryCreate {\n      allowed\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "251c66f4de2b47ee2b6925acd27ac9fb";

export default node;
